import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { DoctoralCommitteeView, getDoctoralCommitteeOptions } from '@/module/Author/DoctoralCommittee';

export const Route = createFileRoute(
  '/_auth/author/_author/doctoral-committee/_doctoralCommittee/$doctoralCommitteeId/_layout/',
)({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.view' },
  },
});

function RouteComponent() {
  const { doctoralCommitteeId } = Route.useParams();
  const { data: doctoralCommittee } = useSuspenseQuery(getDoctoralCommitteeOptions(doctoralCommitteeId));

  return <DoctoralCommitteeView doctoralCommittee={doctoralCommittee} />;
}
